import { FeatureNames } from '../../model/FeatureNames';

export const ORG_URL_FF = FeatureNames.EIAM_7_ORG_SWITCH_URL;

/**
 * Routes that are global / not org-scoped. They must never sit under /orgs/<uid>.
 * Mirrors the `data: { orgScoped: false }` flags in page-routing.module.ts and root-app-routes.module.ts.
 */
export const NON_ORG_SCOPED_ROUTES = new Set<string>([
    'reporting',
    'entitlements',
    // The legacy path the rename redirects from. It has to be here too: without
    // it the redirect is rewritten to /orgs/<uid>/download-center on the way
    // through and never reaches its target.
    'download-center',
    'notifications',
    'empty',
    'marketplace',
    'unsubscribe-notifications',
    'purchase-order-upload',
    'errors',
    'no-role',
]);
